function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{font-size:72px;font-family:AvenirNext-Regular, Avenir Next;}.cls-3{letter-spacing:-0.14em;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "finals"
}, /*#__PURE__*/React.createElement("path", {
  d: "M77.78,232.14c11.26-13,55.63-79.86,70.63-127.47A75.42,75.42,0,1,0,4.28,94.16l0,0c.11.51.24,1,.36,1.53s.3,1.21.46,1.81C17.49,145.25,65.94,218.47,77.78,232.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M77.78,232.14l1.89,1.64c1.48-1.72,3.43-4.22,5.78-7.42a594.7,594.7,0,0,0,33.81-53c12.63-22.18,24.87-46.78,31.53-67.91l-2.38-.75,2.34.88A77.91,77.91,0,1,0,0,77.91,78.57,78.57,0,0,0,1.83,94.69l2.45-.53,1.46-2h0L.33,88.22l1.49,6.49c.12.52.25,1,.37,1.55h0c.15.62.31,1.24.48,1.88v0c3.17,12.17,8.57,25.81,15.09,39.7a581.38,581.38,0,0,0,33,59.64c5.47,8.73,10.61,16.48,15,22.71s7.87,10.92,10.2,13.62L77.78,236l1.89-2.18-1.89-1.64,1.89-1.64c-1.4-1.61-3.43-4.22-5.88-7.58a603.91,603.91,0,0,1-35.63-56.46c-6.54-11.72-12.88-24-18.24-35.89A218.36,218.36,0,0,1,7.5,96.85v0c-.16-.57-.3-1.15-.45-1.75h0c-.12-.52-.25-1-.36-1.5l-2.43.56-1.47,2h0L8.12,100l-1.4-6.4a72.9,72.9,0,1,1,139.35,10.16l0,.06,0,.08c-7.38,23.46-22.16,52-36.48,76.19-7.16,12.1-14.21,23.13-20.15,31.92-3,4.4-5.68,8.24-8,11.37s-4.2,5.57-5.53,7.1l1.89,1.64,1.89-1.64Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.16 135.34 41.16 140.07 114.14 140.07 114.14 135.34 119.42 135.34 119.42 56.77 36.12 56.77 36.12 135.34 41.16 135.34"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 56.52,
  y: 75.28,
  width: 42.17,
  height: 28.94,
  transform: "translate(155.22 179.49) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 48.22,
  y: 73.62,
  width: 42.17,
  height: 28.94,
  transform: "translate(99.62 196) rotate(-157.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 41.17,
  y: 68.92,
  width: 42.17,
  height: 28.94,
  transform: "translate(47.32 186.38) rotate(-135)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 36.47,
  y: 61.88,
  width: 42.17,
  height: 28.94,
  transform: "translate(9.04 158.74) rotate(-112.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 34.82,
  y: 53.57,
  width: 42.17,
  height: 28.94,
  transform: "translate(-12.14 123.94) rotate(-90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 36.47,
  y: 45.26,
  width: 42.17,
  height: 28.94,
  transform: "translate(-19.66 90.05) rotate(-67.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 41.17,
  y: 38.22,
  width: 42.17,
  height: 28.94,
  transform: "translate(-19.02 59.46) rotate(-45)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 48.22,
  y: 33.52,
  width: 42.17,
  height: 28.94,
  transform: "translate(-13.09 30.17) rotate(-22.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 56.52,
  y: 31.86,
  width: 42.17,
  height: 28.94
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 64.83,
  y: 33.52,
  width: 42.17,
  height: 28.94,
  transform: "translate(24.9 -29.23) rotate(22.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 71.87,
  y: 38.22,
  width: 42.17,
  height: 28.94,
  transform: "translate(64.49 -50.3) rotate(45)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 76.58,
  y: 45.26,
  width: 42.17,
  height: 28.94,
  transform: "translate(115.48 -53.35) rotate(67.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 78.23,
  y: 53.57,
  width: 42.17,
  height: 28.94,
  transform: "translate(167.35 -31.27) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 76.58,
  y: 61.88,
  width: 42.17,
  height: 28.94,
  transform: "translate(205.57 15.34) rotate(112.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 71.87,
  y: 68.92,
  width: 42.17,
  height: 28.94,
  transform: "translate(217.65 76.62) rotate(135)"
}), /*#__PURE__*/React.createElement("text", {
  className: "cls-2",
  transform: "translate(44.83 121.76)"
}, /*#__PURE__*/React.createElement("tspan", {
  className: "cls-3"
}, "F"), /*#__PURE__*/React.createElement("tspan", {
  x: 30.1,
  y: 0
}, "J"))));

var SvgTelecomsFibre = function SvgTelecomsFibre(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 155.81 235.96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelecomsFibre, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telecoms-fibre.b51b347f.svg";
export { ForwardRef as ReactComponent };